export default class Styles {
    constructor() {
        if (document.querySelectorAll('.fancy-look').length > 0) {
            this.fancyLookInit();
        }

        if (document.querySelectorAll('.fancy-galery').length > 0 && typeof Fancybox != 'undefined')
        {
            Fancybox.bind('.fancy-galery img', {
                groupAll: true
            })
        }

    }

    fancyLookInit() {
        document.querySelectorAll('.fancy-look').forEach((el) => {

            // selectek
            if (el.classList.contains('select')) {
                const select = el.querySelector('select');

                select.addEventListener('change', (e) => {
                    const text = e.target.options[e.target.selectedIndex].text;
                    if (value) {
                        el.querySelector('.value').innerHTML = text;
                    }
                });

                const selectText = select.options[select.selectedIndex].text;
                if (selectText) {
                    el.querySelector('.value').innerHTML = selectText;
                }
            }
        });
    }

}
